import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Modal, Row, Tabs } from 'antd';
import { isEmpty } from 'underscore';
import moment from 'moment';
import GridView from '../../components/elements/GridView/index';
import Layout from '../../components/layout/Layout';
import FilterSidebar from '../../components/FilterSidebar';
import FilterForm from './FilterForm';
import { getPaginationTotal } from '../../components/elements/GridView/GridViewBase/Pagination';
import CreateDriverForm from '../DriversView/forms/createDriverForm';
import { UserRole } from '../../types/types';

import './drivers.scss';

const { TabPane } = Tabs;

export default function () {
    const { driver, division, user, isExportingDrivers } = this.props;
    const { searchParams, isOpenEditModal } = this.state;

    const formattedData = [];
    if (!isEmpty(driver.drivers)) {
        driver.drivers.map((item, key) => {
            formattedData.push({
                driver: item.full_name,
                division: !isEmpty(item.division_name) ? item.division_name : '-',
                last_journey: item.last_online ? moment(item.last_online).format('DD/MM/YYYY HH:mm') : '-',
                avg_score: `${Math.round(item.average_score)}%`,
                licence_type: item.licence_type,
                status: (
                    <span style={{ textTransform: 'capitalize' }}>{item.driver_status}</span>
                ),
                available: item.driver_availability,
                shift_start: item.shift_start,
                shift_end: item.shift_end,
                last_asset: item.last_asset || '-',
                actions: (
                    <Link
                        className="btn-actions"
                        to={`/drivers/view/${item.id}`}
                    >
                        View
                    </Link>
                ),
            });
        });
    }

    return (
        <Layout
            data-test="pages-drivers"
            className="drivers"
            title={<div>Drivers</div>}
            headerTitle={<div>Drivers Page</div>}
            showFooter={false}
            loading={driver?.driversFetching}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar displayFilter={true}>
                    <FilterForm
                        searchParams={searchParams}
                        onSubmit={(filterData) => this.filterDrivers(filterData)}
                        divisions={division.divisionOptions}
                        driverList={driver.driverList}
                        licenseOptions={driver.licenceTypes}
                    />
                </FilterSidebar>
                <div
                    className="content"
                    style={{ opacity: driver?.driversFetching ? 0 : 1 }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <Row>
                                <Col
                                    span={24}
                                    style={{
                                        textAlign: 'right',
                                        right: '16px',
                                        top: '16px',
                                        position: 'absolute',
                                        zIndex: 999,
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        onClick={this.handleExport}
                                        loading={isExportingDrivers}
                                        data-testid='drivers_export-btn'
                                    >
                                        Export
                                    </Button>
                                </Col>
                            </Row>
                            <Tabs
                                animated={false}
                                className="tabs-restyled"
                            >
                                <TabPane
                                    tab="Drivers"
                                    key="1"
                                >
                                    {[
                                        UserRole.SuperAdmin,
                                        UserRole.Admin,
                                        UserRole.Manager,
                                        UserRole.SalesAdmin
                                    ].includes(user.role) && (
                                            <Row style={{
                                                maxWidth: "50%",
                                                position: 'absolute',
                                                right: '112px',
                                                top: '1px',
                                            }}>
                                                <Col
                                                    span={24}
                                                    style={{
                                                        textAlign: 'right',
                                                        top: '-30px',
                                                        right: 0,
                                                    }}
                                                >
                                                    <Button
                                                        type="primary"
                                                        onClick={() => this.setState({ isOpenEditModal: true })}
                                                        data-testid='driver_create-btn'
                                                    >
                                                        Create
                                                    </Button>
                                                </Col>
                                            </Row>
                                        )}
                                    <div className="section__body">
                                        <GridView
                                            data={formattedData}
                                            onChange={this.handleTableChange}
                                            sortableColumns={['driver_id', 'driver', 'last_journey', 'avg_score', 'department']}
                                            pagination={{
                                                total: driver.pagination.totalCount,
                                                pageSize: driver.pagination.perPage,
                                                current: driver.pagination.currentPage,
                                                showSizeChanger: false,
                                                onChange: (page) => this.paginationChange(page),
                                                showTotal: getPaginationTotal,
                                            }}
                                            scroll={{
                                                x: 'max-content',
                                                y: 'calc(74vh)',
                                            }}
                                        />
                                    </div>
                                </TabPane>
                            </Tabs>
                        </section>
                    </div>
                </div>
            </div>
            <Modal
                open={isOpenEditModal}
                onCancel={() => this.setState({ isOpenEditModal: false })}
                className="with-narrow-padding decreased-top-padding"
                footer={false}
                width={400}
            >
                <div style={{ width: '100%' }}>
                    <CreateDriverForm onSubmit={this.createDriver} />
                </div>
            </Modal>
        </Layout>
    );
}
